import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IDocumentByEmployee } from "src/models/HumanResources/DocumentsByEmployee.models";

interface DocumentByEmployeeState {
  documentsByEmployee: IDocumentByEmployee[];
  documentByEmployeeToEdit: IDocumentByEmployee | null;
}

const initialState: DocumentByEmployeeState = {
  documentsByEmployee: [],
  documentByEmployeeToEdit: null,
};

const DocumentByEmployeeSlice = createSlice({
  name: "DocumentByEmployee",
  initialState,
  reducers: {
    setDocumentByEmployeeList: (
      state,
      action: PayloadAction<IDocumentByEmployee[]>
    ) => {
      state.documentsByEmployee = action.payload;
    },
    concatListDocumentByEmployee: (
      state: DocumentByEmployeeState,
      action: PayloadAction<IDocumentByEmployee[]>
    ) => {
      state.documentsByEmployee = [
        ...state.documentsByEmployee.concat(action.payload),
      ];
    },
    setDocumentByEmployeeToEdit: (
      state,
      action: PayloadAction<IDocumentByEmployee | null>
    ) => {
      state.documentByEmployeeToEdit = action.payload;
    },
    addDocumentByEmployee: (
      state,
      action: PayloadAction<IDocumentByEmployee>
    ) => {
      // console.log("addDocumentByEmployee", action.payload);
      // console.log(
      //   "addDocumentByEmployee Before",
      //   state.documentsByEmployee.values
      // );
      // state.documentsByEmployee.push(action.payload);
      // console.log(
      //   "addDocumentByEmployee After",
      //   state.documentsByEmployee.values
      // );

      // Crear una copia del array existente y agregar el nuevo item
      const updatedDocuments = [...state.documentsByEmployee, action.payload];

      // Actualizar el estado con la nueva copia del array
      state.documentsByEmployee = updatedDocuments;
    },
    updateDocumentByEmployee: (
      state,
      action: PayloadAction<IDocumentByEmployee>
    ) => {
      let itemIndex = state.documentsByEmployee.findIndex(
        item =>
          item.documentByEmployeeId === action.payload.documentByEmployeeId &&
          item.documentTypeId === action.payload.documentTypeId
      );

      if (itemIndex !== -1)
        state.documentsByEmployee[itemIndex] = action.payload;
    },
    deleteDocumentByEmployee: (
      state,
      action: PayloadAction<IDocumentByEmployee>
    ) => {
      const newArray = state.documentsByEmployee.filter(
        item =>
          !(
            item.documentNumber === action.payload.documentNumber &&
            item.documentTypeId === action.payload.documentTypeId
          )
      );
      state.documentsByEmployee = newArray;
    },
  },
});

export const {
  setDocumentByEmployeeList,
  concatListDocumentByEmployee,
  setDocumentByEmployeeToEdit,
  addDocumentByEmployee,
  updateDocumentByEmployee,
  deleteDocumentByEmployee,
} = DocumentByEmployeeSlice.actions;

export default DocumentByEmployeeSlice.reducer;
